import React from 'react';
import {
    Link
} from "react-router-dom";

function Intro() {
    return (
        <>


            <Link to="/menu" className="slick-arrow slick-next">
                <svg className="ontario-icon" aria-hidden="true" focusable="false"
                     viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                    <path d="M10 6L8.6 7.4l4.58 4.6-4.58 4.6L10 18l6-6-6-6z" fill=""/>
                </svg>
            </Link>

            <main id="content" role="main">
                <div className="ontario-row">
                    <div
                        className="ontario-column ontario-small-push-2 ontario-small-8 ontario-margin-top-24-! ontario-margin-bottom-16-!">

                        <h1>UI System JavaScript components</h1>
                        <p>A collection of accessible, responsive, modern front-end components.</p>
                        <p>UI System components are modest and dependency-free. They are built with web standards as a
                            priority and aim to avoid assumptions about special tooling/environment. Care has been taken
                            to
                            make sure each component is compliant, keyboard navigable and properly interpreted by
                            assistive technologies.</p>
                        <p><a href="https://designsystem.ontario.ca/">Read more about Ontario Design System</a></p>
                    </div>
                </div>
            </main>

        </>
    );
}

export default Intro;
